import React, { Component } from "react";
import { Link } from "react-router-dom";
import { I18n } from "react-i18next";
import "../utils/i18n";

class Menu extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return false;
  }
  render() {
    return (
      <I18n>
        {(t, { i18n }) => (
          <div>
            <div
              id="menu"
              className="row hslu-link"
              style={{ marginBottom: "20px" }}
            >
              <div className="span2 detail-space-top-element">
                <i className="icon ion-home" />{" "}
                <Link to="/">{t("navigation.Startseite")}</Link>
              </div>
              <div className="span2 detail-space-top-element">
                <i className="icon ion-search" />{" "}
                <Link to="/search-unified/orgelsuche">
                  {t("navigation.Orgelsuche")}
                </Link>
              </div>
              <div className="span2 detail-space-top-element">
                <i className="icon ion-person" />{" "}
                <Link to="/search-unified/orgelbauer">
                  {t("navigation.Orgelbauersuche")}
                </Link>
              </div>
              <div className="span2 detail-space-top-element">
                <i className="icon ion-person" />{" "}
                <Link to="/search-unified/karte">
                  {t("navigation.Kartensuche")}
                </Link>
              </div>
              <div className="span2 detail-space-top-element">
                <i className="icon ion-person" />{" "}
                <Link to="/recherche">{t("navigation.Recherche")}</Link>
              </div>
            </div>
          </div>
        )}
      </I18n>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/app-header/Menu.js